import type {RouteRecordRaw} from 'vue-router';
import {createPropositionGuard} from '@myparcel-frontend/proposition';
import {noOrderManagementGuard} from '../guards/order-management-guard';

export const shopSettingsReturnsRoutes: RouteRecordRaw[] = [
  {
    name: 'shop-settings-returns-index',
    path: 'retour',
    component: () => import('@/views/Settings/Shop/Returns/ReturnSettingsIndex.vue'),
    meta: {
      permissions: ['updateShopReturnSettings'],
      title: (t) => t('shipping.return', 2),
    },
    beforeEnter: createPropositionGuard((proposition) => proposition.settings.shop.enableReturns, {
      name: 'dashboard',
    }),
    children: [
      {
        name: 'shop-settings-returns-policy',
        path: '',
        component: () => import('@/views/Settings/Shop/Returns/Policy/ReturnsPolicy.vue'),
        meta: {
          permissions: ['updateShopReturnSettings'],
          titleBarHeader: 'shipping.return',
          title: (t) => t('shipping.return', 2),
        },
      },
      {
        name: 'shop-settings-returns-portal',
        path: 'portal',
        component: () => import('@/views/Settings/Shop/Returns/Portal/ReturnPortal.vue'),
        meta: {
          permissions: ['updateShopReturnSettings'],
          titleBarHeader: 'shipping.return',
          title: (t) => t('shipping.return', 2),
        },
      },
      {
        name: 'shop-settings-returns-rules',
        path: 'rules',
        component: () => import('@/views/Settings/Shop/Returns/Rules/ReturnRulesView.vue'),
        beforeEnter: noOrderManagementGuard,
        meta: {
          permissions: ['updateShopReturnSettings'],
          titleBarHeader: 'shipping.return',
          title: (t) => t('shipping.return', 2),
        },
      },
      {
        name: 'shop-settings-returns-rules-create',
        path: 'rules/create',
        props: true,
        component: () => import('@/views/Settings/Shop/Returns/RulesCreate/RulesCreate.vue'),
        meta: {
          permissions: ['updateShopReturnSettings'],
          titleBarHeader: 'rules.legacy.return.create',
          title: (t) => t('rules.legacy.return.create'),
          hasTabMenu: false,
          rootRouteName: 'shop-settings-returns-rules',
        },
      },
      {
        name: 'shop-settings-returns-rules-edit',
        path: 'rules/:ruleId',
        props: true,
        component: () => import('@/views/Settings/Shop/Returns/RulesEdit/RulesEdit.vue'),
        meta: {
          permissions: ['updateShopReturnSettings'],
          titleBarHeader: 'rules.legacy.return.edit',
          title: (t) => t('rules.legacy.return.edit'),
          hasTabMenu: false,
          rootRouteName: 'shop-settings-returns-rules',
        },
      },
    ],
  },
];
